[
  {
    "id": "miedziany-pierscien",
    "name": "Miedziany Pierścień",
    "description": "Prosta obrączka, która dodaje pewności ręce.",
    "kind": "pierscien",
    "rarity": "zwykly",
    "color": "#c87a3e",
    "modifiers": [
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.06
      }
    ]
  },
  {
    "id": "kosciany-amulet",
    "name": "Kościany Amulet",
    "description": "Wisior z kości strażnika grobów. Trzyma przy życiu.",
    "kind": "amulet",
    "rarity": "zwykly",
    "color": "#e8dcc0",
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "add",
        "value": 20
      }
    ]
  },
  {
    "id": "talizman-wedrowca",
    "name": "Talizman Wędrowca",
    "description": "Kamyk z drogi, który niesie nogi same.",
    "kind": "talizman",
    "rarity": "zwykly",
    "color": "#7fbf6a",
    "modifiers": [
      {
        "stat": "moveSpeed",
        "op": "mul",
        "value": 0.07
      }
    ]
  },
  {
    "id": "pierscien-zbieracza",
    "name": "Pierścień Zbieracza",
    "description": "Łupy same ciągną do właściciela.",
    "kind": "pierscien",
    "rarity": "zwykly",
    "color": "#7ee8ff",
    "modifiers": [
      {
        "stat": "pickupRadius",
        "op": "mul",
        "value": 0.3
      }
    ]
  },
  {
    "id": "rzemienny-amulet",
    "name": "Rzemienny Amulet",
    "description": "Na rzemieniu kawałek starej zbroi.",
    "kind": "amulet",
    "rarity": "zwykly",
    "color": "#9aa8b8",
    "modifiers": [
      {
        "stat": "armor",
        "op": "add",
        "value": 5
      }
    ]
  },
  {
    "id": "talizman-zrodla",
    "name": "Talizman Źródła",
    "description": "Woda z czystego źródła zamknięta w szkle.",
    "kind": "talizman",
    "rarity": "zwykly",
    "color": "#6fdc6f",
    "modifiers": [
      {
        "stat": "regen",
        "op": "add",
        "value": 0.6
      }
    ]
  },
  {
    "id": "pierscien-ostrza",
    "name": "Pierścień Ostrza",
    "description": "Szlif tak ostry, że kaleczy samo patrzenie.",
    "kind": "pierscien",
    "rarity": "rzadki",
    "color": "#ffcc4d",
    "modifiers": [
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.06
      },
      {
        "stat": "critDamage",
        "op": "add",
        "value": 0.25
      }
    ]
  },
  {
    "id": "amulet-krwi",
    "name": "Amulet Krwi",
    "description": "Każdy pokonany wróg oddaje trochę sił.",
    "kind": "amulet",
    "rarity": "rzadki",
    "color": "#e0484a",
    "modifiers": [
      {
        "stat": "lifeOnKill",
        "op": "add",
        "value": 1
      }
    ]
  },
  {
    "id": "cierniowy-talizman",
    "name": "Cierniowy Talizman",
    "description": "Kto dotknie, ten krwawi.",
    "kind": "talizman",
    "rarity": "rzadki",
    "color": "#5aa04a",
    "modifiers": [
      {
        "stat": "thorns",
        "op": "add",
        "value": 12
      }
    ]
  },
  {
    "id": "pierscien-pospiechu",
    "name": "Pierścień Pośpiechu",
    "description": "Czas między ciosami skraca się sam.",
    "kind": "pierscien",
    "rarity": "rzadki",
    "color": "#8fb4ff",
    "modifiers": [
      {
        "stat": "cooldown",
        "op": "mul",
        "value": -0.08
      }
    ]
  },
  {
    "id": "amulet-cienia",
    "name": "Amulet Cienia",
    "description": "Ciosy wrogów trafiają w miejsce, gdzie przed chwilą stałeś.",
    "kind": "amulet",
    "rarity": "rzadki",
    "color": "#6a5a8a",
    "modifiers": [
      {
        "stat": "dodgeChance",
        "op": "add",
        "value": 0.08
      }
    ]
  },
  {
    "id": "talizman-szczescia",
    "name": "Talizman Szczęścia",
    "description": "Czterolistny liść w bursztynie.",
    "kind": "talizman",
    "rarity": "rzadki",
    "color": "#ffd04a",
    "modifiers": [
      {
        "stat": "luck",
        "op": "add",
        "value": 0.4
      },
      {
        "stat": "goldGain",
        "op": "mul",
        "value": 0.15
      }
    ]
  },
  {
    "id": "pierscien-katowski",
    "name": "Pierścień Kata",
    "description": "Ciężki, czarny sygnet. Słabi nie wstają po ciosie.",
    "kind": "pierscien",
    "rarity": "epicki",
    "color": "#3a2a3a",
    "modifiers": [
      {
        "stat": "executeBelow",
        "op": "add",
        "value": 0.08
      },
      {
        "stat": "damage",
        "op": "mul",
        "value": 0.05
      }
    ]
  },
  {
    "id": "amulet-bariery",
    "name": "Amulet Bariery",
    "description": "Kryształ tworzy wokół ciebie migoczącą osłonę.",
    "kind": "amulet",
    "rarity": "epicki",
    "color": "#7ee8ff",
    "modifiers": [
      {
        "stat": "barrier",
        "op": "add",
        "value": 0.2
      }
    ]
  },
  {
    "id": "talizman-burzy",
    "name": "Talizman Burzy",
    "description": "Iskry tańczą wokół twoich ataków.",
    "kind": "talizman",
    "rarity": "epicki",
    "color": "#b98cff",
    "modifiers": [
      {
        "stat": "area",
        "op": "mul",
        "value": 0.12
      },
      {
        "stat": "projectileSpeed",
        "op": "mul",
        "value": 0.15
      }
    ]
  },
  {
    "id": "pierscien-mnogosci",
    "name": "Pierścień Mnogości",
    "description": "Każdy pocisk ma brata bliźniaka.",
    "kind": "pierscien",
    "rarity": "epicki",
    "color": "#c58cff",
    "modifiers": [
      {
        "stat": "projectileCount",
        "op": "add",
        "value": 1
      }
    ]
  },
  {
    "id": "serce-pustkowi",
    "name": "Serce Pustkowi",
    "description": "Bije własnym rytmem. Leczy, chroni i rani tych, którzy podejdą.",
    "kind": "amulet",
    "rarity": "legendarny",
    "color": "#ff6a3d",
    "modifiers": [
      {
        "stat": "maxHealth",
        "op": "mul",
        "value": 0.2
      },
      {
        "stat": "regen",
        "op": "add",
        "value": 1
      },
      {
        "stat": "thorns",
        "op": "add",
        "value": 15
      }
    ]
  },
  {
    "id": "oko-wiecznosci",
    "name": "Oko Wieczności",
    "description": "Widzi słabe punkty, zanim wróg zrobi krok.",
    "kind": "talizman",
    "rarity": "legendarny",
    "color": "#ff9a1f",
    "modifiers": [
      {
        "stat": "critChance",
        "op": "add",
        "value": 0.1
      },
      {
        "stat": "critDamage",
        "op": "add",
        "value": 0.5
      },
      {
        "stat": "executeBelow",
        "op": "add",
        "value": 0.05
      }
    ]
  }
]